import { createOidcAuthClient } from '@phoenix/auth';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { StaffApp } from './App';
import { staffConfig } from './config';
import { registerAppShell } from './offline/serviceWorker';

const authClient = createOidcAuthClient({
  authority: staffConfig.oidcAuthority,
  clientId: staffConfig.oidcClientId,
});

registerAppShell();

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <StaffApp authClient={authClient} apiBaseUrl={staffConfig.apiBaseUrl} />
    </StrictMode>,
  );
}
